"use strict";

function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

(function ($, window, document) {
    var $win = $(window);
    var $doc = $(document);
    var $body = $("body");
    var $header = $(".header");
    var headerHeight = $header.outerHeight();
    var scrollHeight = $win.scrollTop();
    var winWidth = $win.outerWidth();
    var isMobileView = winWidth < 767;

    $(".nav .nav__dd").each((index, navDd) => {
        let $navDd = $(navDd);
        let $navItem = $navDd.parent();

        $navDd.siblings("a").on("click", (e) => {
            let $this = $(e.currentTarget);

            if (
                !$navItem.hasClass("is-expanded") ||
                $this.hasClass("nav__arrow") ||
                $this.attr("href") == "#"
            ) {
                e.preventDefault();
            }

            $this
                .siblings(".nav__dd")
                .slideToggle()
                .parent()
                .toggleClass("is-expanded");
        });
    });

    $(".nav-trigger").on("click", (e) => {
        e.preventDefault();
        $body.toggleClass("is-nav-open");
    });

    function headerSizes() {
        headerHeight = $header.outerHeight();
        if ($body.hasClass("is-passed-header")) {
            $body.css({ "--sticky-header-height": headerHeight + "px" });
        } else {
            $body.css({ "--header-height": headerHeight + "px" });
        }
    }

    //Video Controls
    $(".video-block").each((index, videoSection) => {
        let $videoSection = $(videoSection);
        let $video = $videoSection.find("video");

        $videoSection.find(".js-video-mute").on("click", (e) => {
            e.preventDefault();
            $videoSection.toggleClass("is-muted");
            $video[0].muted = !$video[0].muted;
        });
    });

    //Sliders
    $(".js-slider-content-wrapper").each((index, sliderWrapper) => {
        let $sliderWrapper = $(sliderWrapper);
        let $slider = $sliderWrapper.find(".slider__slides");
        let $sliderBtnLeft = $sliderWrapper.find(".slider-nav .slick-prev");
        let $sliderBtnRight = $sliderWrapper.find(".slider-nav .slick-next");

        $slider.slick({
            infinite: true,
            slidesToShow: 1,
            arrows: true,
            dots: false,
            prevArrow: $sliderBtnLeft,
            nextArrow: $sliderBtnRight,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 767,
                    settings: {
                        centerMode: true,
                        centerPadding: "40px 0 0",
                    },
                },
            ],
        });
    });

    $(".js-related-books-slider").each((index, sliderWrapper) => {
        let $sliderWrapper = $(sliderWrapper);
        let $slider = $sliderWrapper.find(".slider__slides");

        let $sliderBtnLeft = $sliderWrapper.closest('.section-related-books').find(".slider-nav .slick-prev");
        let $sliderBtnRight = $sliderWrapper.closest('.section-related-books').find(".slider-nav .slick-next");

        $slider.slick({
            infinite: false,
            slidesToShow: 4.2,
            arrows: true,
            dots: false,
            prevArrow: $sliderBtnLeft,
            nextArrow: $sliderBtnRight,
            adaptiveHeight: false,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 3.1,
                    },
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: 1.2,
                    },
                },
            ],
        });
    });

    $(".js-slider-news .slider__slides").each((index, sliderWrapper) => {
        var slideCheker;
        var sliderVisibleBorder;
        var $sliderWrapper = $(sliderWrapper);

        $sliderWrapper
            .on("init", function (event, slick) {
                $(slick.$slides).each((inx, slide) => {
                    let $slide = $(slide);
                    if ($slide.hasClass("slick-active")) {
                        $slide.addClass("is-opacity");
                    }
                });
                $win.on("load resize", () => {
                    // $sliderWrapper.slick("refresh");
                    slick.$slider
                        .parents(".slider-news")
                        .css(
                            "--media-height",
                            slick.$slides
                                .eq(0)
                                .find(".article__media")
                                .outerHeight() + "px"
                        );
                    sliderVisibleBorder =
                        $(slick.$list).offset().left +
                        $(slick.$list).outerWidth();
                });
            })
            .slick({
                infinite: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                        },
                    },
                ],
            })
            .on(
                "beforeChange",
                function (event, slick, currentSlide, nextSlide) {
                    let rightDirection = currentSlide < nextSlide;
                    let lastVisibleSlide = rightDirection
                        ? nextSlide + 2
                        : nextSlide + 3;
                    slideCheker = setInterval(() => {
                        checkIsSlideInVp(
                            slick.$slides[lastVisibleSlide],
                            sliderVisibleBorder
                        );
                    }, 30);
                }
            )
            .on(
                "afterChange",
                function (event, slick, currentSlide, nextSlide) {
                    clearInterval(slideCheker);
                }
            );
    });

    let $sliderWrapperNewsAlt = $(".js-slider-news-alt .slider__slides");
    $sliderWrapperNewsAlt.each((index, sliderWrapper) => {
        var slideCheker;
        var sliderVisibleBorder;
        let $sliderWrapper = $(sliderWrapper);

        $sliderWrapper
            .on("init", function (event, slick) {
                $(slick.$slides).each((inx, slide) => {
                    let $slide = $(slide);
                    if ($slide.hasClass("slick-active")) {
                        $slide.addClass("is-opacity");
                    }
                });

                $win.on("load resize", () => {
                    // $sliderWrapper.slick("refresh");
                    sliderVisibleBorder =
                        $(slick.$list).offset().left +
                        $(slick.$list).outerWidth();
                });
            })
            .slick({
                infinite: false,
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            arrows: false,
                        },
                    },
                ],
            })
            .on(
                "beforeChange",
                function (event, slick, currentSlide, nextSlide) {
                    let rightDirection = currentSlide < nextSlide;
                    let lastVisibleSlide = rightDirection
                        ? nextSlide + 1
                        : nextSlide + 2;
                    // $(slick.$slides[lastVisibleSlide]).addClass('is-test').siblings().removeClass('is-test')
                    slideCheker = setInterval(() => {
                        checkIsSlideInVp(
                            slick.$slides[lastVisibleSlide],
                            sliderVisibleBorder
                        );
                    }, 30);
                }
            )
            .on(
                "afterChange",
                function (event, slick, currentSlide, nextSlide) {
                    clearInterval(slideCheker);
                }
            );
    });

    let checkIsSlideInVp = (slide, sliderVisibleBorder) => {
        if (slide === undefined) {
            return;
        }

        let $slide = $(slide);
        let sliderOffsetCentet =
            $slide.offset().left + $slide.outerHeight() / 2;
        $slide.toggleClass(
            "is-opacity",
            sliderVisibleBorder > sliderOffsetCentet
        );
    };

    function sliderBaseSlider($elem) {
        $elem.slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            adaptiveHeight: false,
        });
    }
    sliderBaseSlider($(".slider-base .slider__slides"));

    $(".slider-base--no-pagination .slider__slides").slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
    });

    $(".js-slider-gallery-alt .slider__slides").slick({
        infinite: false,
        variableWidth: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
    });

    $(".js-slider-gallery-overview .slider__slides")
        .on("init", function (event, slick) {
            $win.on("load resize orientationchange", () => {
                setTimeout(function () {
                    $(slick.$slider.parents(".slider-gallery-overview")).css(
                        "--image-height",
                        slick.$slider
                            .find(".slick-active figure")
                            .outerHeight() + "px"
                    );
                }, 300);
            });
        })
        .slick({
            fade: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            adaptiveHeight: true,
        })
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
            $(slick.$slider.parents(".slider-gallery-overview")).css(
                "--image-height",
                slick.$slider.find("figure").eq(nextSlide).outerHeight() + "px"
            );
        });

    $(".js-slider-gallery .slider__slides")
        .on("init", function (event, slick) {
            let sliderCount = slick.$slides.length;

            slick.$slides.each((index, slide) => {
                let $slide = $(slide);
                let path = $slide.find("img").attr("src");

                if (slick.$dots === null) {
                    return;
                }

                slick.$dots
                    .find("li")
                    .eq(index)
                    .html(`<img src="${path}" alt="img">`);
            });
        })
        .slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            dots: true,
            arrows: true,
        });

    $(".js-slider-hero-holder").each((index, section) => {
        let $section = $(section);
        let $slider = $section.find(".js-slider-hero .slider__slides");
        let $outerPaging = $section.find(".js-slider-paging-outer ul");
        let autoplaySpeed = 4000;

        $slider
            .on("init", function (event, slick) {
                let sliderCount = slick.$slides.length;
                if (sliderCount <= 1) {
                    return;
                }

                for (var i = 0; i < sliderCount; i++) {
                    $outerPaging.append(
                        `<li ${i == 0 && 'class="is-active"'}></li>`
                    );
                }

                $section.css("--autoplay-speed", autoplaySpeed);

                $outerPaging.find("li").on("click", (e) => {
                    e.preventDefault();
                    let $this = $(e.currentTarget);

                    $slider.slick("slickGoTo", $this.index());
                });
            })
            .slick({
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                autoplay: true,
                autoplaySpeed: autoplaySpeed,
                pauseOnFocus: false,
                focusOnSelect: false,
                // pauseOnHover:false
            })
            .on(
                "beforeChange",
                function (event, slick, currentSlide, nextSlide) {
                    $outerPaging
                        .find("li")
                        .eq(nextSlide)
                        .addClass("is-active")
                        .siblings()
                        .removeClass("is-active");
                }
            )
            .hover(
                function () {
                    $section.addClass("is-hover");
                },
                function () {
                    $section.removeClass("is-hover");
                }
            );
    });

    let $heroWrapper = $(".js-hero-animation-wrapper");
    let $hero = $heroWrapper.find(".hero");
    $heroWrapper.parents("body").addClass("has-hero-anime");

    let heroFixedFunction = () => {
        let wrapperHeight = $heroWrapper.outerHeight();
        let heroHeight = $hero.outerHeight();
        let heroScrollLength = wrapperHeight - heroHeight;
        let disableAction = 0.1; // 10% pause Action
        let proggres = scrollHeight / (heroScrollLength - headerHeight);
        let actionsProggres = (proggres - disableAction) / (1 - disableAction);

        $win.on("load", function () {
            wrapperHeight = $heroWrapper.outerHeight();
            heroHeight = $hero.outerHeight();
            heroScrollLength = wrapperHeight - heroHeight;

            setTimeout(function () {
                wrapperHeight = $heroWrapper.outerHeight();
                heroHeight = $hero.outerHeight();
                heroScrollLength = wrapperHeight - heroHeight;
            }, 300);
        })
        .on("resize", function () {
            wrapperHeight = $heroWrapper.outerHeight();
            heroHeight = $hero.outerHeight();
            heroScrollLength = wrapperHeight - heroHeight;
            proggres = scrollHeight / (heroScrollLength - headerHeight);
            actionsProggres = (proggres - disableAction) / (1 - disableAction);
        })
        .on("load scroll", function () {
            heroHeight = $hero.outerHeight();
            proggres = scrollHeight / heroScrollLength;
            actionsProggres = (proggres - disableAction) / (1 - disableAction);

            if (actionsProggres > 0) {
                $hero.addClass("start-animate");
                $hero
                    .find(".js-slider-hero .slider__slides")
                    .slick("slickPause");
                $heroWrapper.toggleClass("is-sticky", actionsProggres > 1);
            } else {
                $hero.removeClass("start-animate");
                $hero
                    .find(".js-slider-hero .slider__slides")
                    .slick("slickPlay");
            }

            if (actionsProggres <= 0) {
                actionsProggres = 0;
            }
            if (actionsProggres >= 1) {
                actionsProggres = 1;
            }

            $hero.css("--proggres", actionsProggres);
        });
    };

    let intFormFields = () => {
        $('body')
            .on("focusin", ".gfield input, .gfield select, .gfield textarea", function () {
                let $this = $(this);
                $this.parents(".gfield").addClass("hastext");
            })
            .on("focusout", ".gfield input, .gfield select, .gfield textarea", function () {
                let $this = $(this);
                var inputValue = $this.val();

                if ($this[0].tagName == "SELECT") {
                    if ($this[0].value == "") {
                        $this.parents(".gfield").removeClass("hastext");
                    }
                }

                if (
                    inputValue == "" &&
                    ($this[0].tagName == "INPUT" ||
                        $this[0].tagName == "TEXTAREA")
                ) {
                    $this.parents(".gfield").removeClass("hastext");
                }
            });

        $(".gfield select").trigger("focusin").trigger("focusout");

        $doc.on('gform_post_render', function(e, form_id, current_page){
            $('#gform_' + form_id).find( ".gfield input, .gfield select, .gfield textarea" ).each(function() {
                let $this = $(this);
                var inputValue = $this.val();

                if ($this[0].tagName == "SELECT") {
                    if ($this[0].value !== "") {
                        $this.parents(".gfield").addClass("hastext");
                    }
                }

                if (
                    inputValue !== "" &&
                    ($this[0].tagName == "INPUT" ||
                        $this[0].tagName == "TEXTAREA")
                ) {
                    $this.parents(".gfield").addClass("hastext");
                }
            });
        });

        $doc.on('gform_confirmation_loaded', function (event, formID) {
            if (formID == 4) { // form ID 4 = popup signup newsletter form
                $('.popup__form-copy').hide();
            }
        });
    };

    let intMobileSliders = () => {
        $(".js-mobile-slider").each(function () {
            var $carousel = $(this);

            if (!isMobileView) {
                if ($carousel.hasClass("slick-initialized")) {
                    $carousel.slick("unslick");
                }
            } else {
                if (!$carousel.hasClass("slick-initialized")) {
                    if ($carousel.hasClass("mobile-slider-events")) {
                        $carousel.slick({
                            arrows: false,
                            infinite: false,
                            variableWidth: false,
                            slidesToShow: 1,
                            mobileFirst: true,
                            swipeToSlide: true,
                        });
                    }

                    if ($carousel.hasClass("mobile-slider-news")) {
                        $carousel.slick({
                            arrows: false,
                            infinite: false,
                            variableWidth: false,
                            slidesToShow: 1,
                            mobileFirst: true,
                            swipeToSlide: true,
                        });
                    }
                }
            }
        });
    };

    $(".js-team-link").on("click", (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let $image = $this.siblings(".team__media").data("popup-image");
        let $title = $this.siblings(".team__title").html();
        let $content = $this.siblings(".team__content").html();

        $body.addClass("overflow-hidden");
        $body.append(`
			<div class="efr-popup popup--team is-open">
				<div class="shell">
					<div class="popup__inner">
						<a href="#" class="popup__close-area js-close-popup"></a>
						<a href="#" class="btn-close js-close-popup"></a>

						<div class="popup__scroll">
							<div class="team team--popup">
								<div class="team__media">
									<img src="${$image}" alt="${$title}" loading="lazy">
								</div>

								<div class="team__title">
									${$title}
								</div>

								<div class="team__content">
									${$content}
								</div>
							</div>
						</div><!-- /.popup__scroll -->
					</div><!-- /.popup__inner -->
				</div><!-- /.shell -->
			</div><!-- /.efr-popup -->
		`);

        setTimeout(function () {
            $body.find(".popup--team").addClass("is-open");
        }, 100);

        $body.find(".popup--team .js-close-popup").on("click", (e) => {
            e.preventDefault();

            let $this = $(e.currentTarget);
            let $popup = $this.parents(".popup--team");

            $popup.removeClass("is-open");
            $body.removeClass("overflow-hidden");

            setTimeout(function () {
                $popup.remove();
            }, 10);
        });
    });

    $(".js-video-link").on("click", (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let isExternalVideo = $this.hasClass("video-link--external");
        $body.addClass("overflow-hidden");

        $body.append(`
			<div class="efr-popup popup--video ">
				<div class="shell">
					<div class="popup__inner">
						<div class="popup__scroll">
							<a href="#" class="btn-close"></a>

							${
                                isExternalVideo
                                    ? `<iframe width="560" height="315" src="${$this.attr(
                                          "href"
                                      )}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>`
                                    : `<video width="320" height="240" controls muted playsinline loop autoplay>
										<source src="${$this.attr("href")}" type="video/mp4">
									</video>`
                            }


						</div><!-- /.popup__scroll -->
					</div><!-- /.popup__inner -->
				</div><!-- /.shell -->
			</div><!-- /.efr-popup -->
		`);

        setTimeout(function () {
            $body.find(".popup--video").addClass("is-open");
        }, 100);

        $body.find(".popup--video .btn-close").on("click", (e) => {
            e.preventDefault();

            let $this = $(e.currentTarget);
            let $popup = $this.parents(".popup--video");

            $popup.removeClass("is-open");
            $body.removeClass("overflow-hidden");

            setTimeout(function () {
                $popup.remove();
            }, 10);
        });
    });

    $(".js-open-image-pop a").on("click", (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        let imagePath = $this.parent().attr("data-image-path");
        $body.addClass("overflow-hidden");

        $body.append(`
			<div class="efr-popup popup--image">
				<div class="shell">
					<div class="popup__inner">
						<div class="popup__scroll">
							<a href="#" class="btn-close"></a>
							<img src="${imagePath}" alt="img">
						</div><!-- /.popup__scroll -->
					</div><!-- /.popup__inner -->
				</div><!-- /.shell -->
			</div><!-- /.efr-popup -->
		`);

        setTimeout(function () {
            $body.find(".popup--image").addClass("is-open");
        }, 100);

        $body.find(".popup--image .btn-close").on("click", (e) => {
            e.preventDefault();

            let $this = $(e.currentTarget);
            let $popup = $this.parents(".popup--image");

            $popup.removeClass("is-open");
            $body.removeClass("overflow-hidden");

            setTimeout(function () {
                $popup.remove();
            }, 10);
        });
    });

    $body.on("click", '.js-exhibition-tile-popup', (e) => {
        e.preventDefault();

        let $this        = $(e.currentTarget);
        let this_content = JSON.parse( $this.attr("data-popup-content") );
        let $buttons     = $this.closest('.js-exhibition-posts').find('.js-exhibition-tile-popup');
        let slides       = '';

        $buttons.each(function(i, button) {
            let content = JSON.parse( $(button).attr("data-popup-content") );

            slides += `<div class="slide">
                            <img src="${content.image_url}">
                            <h6>${content.title}</h6>
                            ${content.description}
                            ${content.lender}
                            ${content.link}
                        </div>`;
        });

        $body.addClass("overflow-hidden");

        $body.append(`<div class="efr-popup popup--exhibition-tile">
                            <div class="shell">
                                <div class="popup__inner">
                                    <div class="popup__scroll js-exhibition-popup-slider">
                                        <a href="#" class="btn-close"></a>
                                        <div class="slider__slides">
                                            ${slides}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>`);

        $(".js-exhibition-popup-slider .slider__slides").one('init', function(e, slick){
            $body.find(".popup--exhibition-tile").addClass("is-open");
        });

        $(".js-exhibition-popup-slider .slide img").eq(this_content.index).one('load', function() {
            $(".js-exhibition-popup-slider .slider__slides").slick({
                infinite: true,
                arrows: true,
                dots: false,
                adaptiveHeight: true,
                initialSlide: this_content.index,
            });
        });
    });

    $body.on("click", ".popup--exhibition-tile .btn-close", (e) => {
        e.preventDefault();

        let $this = $(e.currentTarget);
        let $popup = $this.parents(".popup--exhibition-tile");

        $popup.removeClass("is-open");
        $body.removeClass("overflow-hidden");

        setTimeout(function () {
            $popup.remove();
        }, 10);
    });

    $(".form-search").on("change", "#headerSearch-searchCategory", (e) => {
        let $this = $(e.currentTarget);
        if ($this.val() == "menziesCollection") {
            $(".form-search .js-advanced-search")
                .removeClass("hidden")
                .addClass("visible");
        } else {
            $(".form-search").removeClass("is-expanded");
            $(".form-search .js-advanced-search")
                .removeClass("visible")
                .addClass("hidden");
        }
    });

    $(".form-search .btn-adv-search a").on("click", (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $this.parents(".form-search").toggleClass("is-expanded");
    });

	$('#search-results-filter input').on('change', function(e) {
		efr_trigger_filter_update();
	});

	function efr_trigger_filter_update() {
		$('#search-results-filter button[type="submit"]').trigger('click');
	}

    $(".search-filter--searchCategory").on(
        "change",
        "input[type=radio]",
        (e) => {
            let $this = $(e.currentTarget);
            if ($this.val() == "menziesCollection") {
                $(".accordion__section--advanced").addClass(
                    "accordion__section--advanced-expanded"
                );
            } else {
                $(".accordion__section--advanced").removeClass(
                    "accordion__section--advanced-expanded"
                );
            }
        }
    );

    function efr_prevent_page_scroll() {
        $("body").css(
            "margin-right",
            window.innerWidth - $("body").width() + "px"
        ); // Add right margin in case there was a scrollbar.
        $("body").css("overflow", "hidden");
    }

    function efr_allow_page_scroll() {
        $("body").css("overflow", "");
        $("body").css("margin-right", "");
    }

    $(".js-popup-gallery").on("click", (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $("." + $this.attr("href")).addClass("is-open");

        efr_prevent_page_scroll();
    });

    $(".efr-popup .btn-close").on("click", (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $this.parents(".efr-popup").removeClass("is-open");

        efr_allow_page_scroll();
    });

    $doc.keyup(function (e) {
        if (e.keyCode === 27) {
            // 27 = Escape
            if ($(".efr-popup.is-open").length) {
                $(".efr-popup.is-open").removeClass("is-open");

                efr_allow_page_scroll();
            }
        }
    });

    $(".js-search-toggle").on("click", (e) => {
        e.preventDefault();
        $body.toggleClass("is-form-visible");
    });

    let firstOpenSliderAcc = true;
    $(".accordion .accordion__head").on("click", (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        if ($this.parent().hasClass("accordion__section--no-collapse")) {
            return false;
        }
        let $sliderEvents = $this
            .siblings(".accordion__body")
            .find(".mobile-slider-events");

        $this.siblings().slideToggle().parent().toggleClass("is-expanded");
        if (
            $sliderEvents &&
            $this.parent().hasClass("is-expanded") &&
            isMobileView
        ) {
            $sliderEvents.slick("resize").slick("refresh");
            setTimeout(function () {
                $sliderEvents.slick("resize").slick("refresh");
            }, 200);
        }
    });

    $(".js-show-filter").on("click", (e) => {
        e.preventDefault();
        $body.toggleClass("is-filters-visible");
    });

    let animateOnScroll = () => {
        $(".js-animate").each((index, element) => {
            let $this = $(element);
            let sectionTop = $this.offset().top;
            let scrollBottom = scrollHeight + $win.outerHeight();
            let sectionStartPosition = 50;

            if (sectionTop + sectionStartPosition < scrollBottom) {
                $this.addClass("is-animated");
            }
        });
    };

    $(".js-block-dd select").selectric();
    $(".js-block-dd select");
    $(".js-field-select select").selectric();

    $(".js-range").each((index, section) => {
        let $rangeSection = $(section);
        let defMinValue = parseInt($rangeSection.attr("data-min"));
        let defMaxValue = parseInt($rangeSection.attr("data-max"));
        let selectedMinValue = $rangeSection.attr("data-selected-range-from");
        let selectedMaxValue = $rangeSection.attr("data-selected-range-to");
        let $rangeMin = $rangeSection.find(
            ".range__indicatiors span:first-child"
        );
        let $rangeMax = $rangeSection.find(
            ".range__indicatiors span:last-child"
        );
        let $rangeSlider = $rangeSection.find(".range__slider");
        let $dateRangeFrom = $rangeSection.find("input[name=dateRangeFrom]");
        let $dateRangeTo = $rangeSection.find("input[name=dateRangeTo]");

        let loadValueMin = defMinValue;
        let loadValueMax = defMaxValue;

        if (typeof selectedMinValue != "undefined")
            loadValueMin = parseInt(selectedMinValue);
        if (typeof selectedMaxValue != "undefined")
            loadValueMax = parseInt(selectedMaxValue);
        $rangeMin.html(loadValueMin);
        $rangeMax.html(loadValueMax);

        $rangeSlider.slider({
            range: true,
            min: defMinValue,
            max: defMaxValue,
            values: [loadValueMin, loadValueMax],
            slide: function (event, ui) {
                $rangeMin.html(ui.values[0]);
                $dateRangeFrom.val(ui.values[0]);
                $rangeMax.html(ui.values[1]);
                $dateRangeTo.val(ui.values[1]);
            },
			stop: function( event, ui ) {
				efr_trigger_filter_update();
			}
        });
    });

    $(".field-select-dd .field__content").mCustomScrollbar();

    let $stickyAsideList = $(".js-sticky-aside");
    function stickyAside() {
        $stickyAsideList.each(function (index, stickyAside) {
            let $holder = $(stickyAside);
            let $content = $holder.find(".sticky__content");
            let holderOffsetTop = $holder.offset().top;
            let contentHeight = $content.outerHeight();
            let contentWidth = $holder.outerWidth();

            $holder.css({
                "--content-height": contentHeight / 10 + "rem",
                "--content-width": contentWidth / 10 + "rem",
            });

            let stickyAreaStart = scrollHeight + headerHeight;

            if (!!$body.hasClass("visible-sticky-header")) {
                stickyAreaStart += headerHeight;
                if (!!navSecHeight) {
                    stickyAreaStart += navSecHeight;
                }
            }

            let isSticky = stickyAreaStart >= holderOffsetTop;
            let contentHitBottom =
                stickyAreaStart + contentHeight >
                holderOffsetTop + $holder.outerHeight();

            $holder.toggleClass("is-sticky", isSticky);
            $holder.toggleClass("is-sticky-bottom", contentHitBottom);
        });
    }

    let $scrollSpyLink = $(".js-scrollspy ul a");

    function scrollSpy(event) {
        $scrollSpyLink.each(function () {
            let $this = $(this);
            var $id = $($this.attr("href"));

            if (!!$id.length) {
                let elementTop = $id.offset().top;
                let elementHeight = $id.height();


                let tolerants = headerHeight;

                if (!!$this.parents(".sticky-band-fulltime").length) {
                    tolerants =
                        headerHeight +
                        $this.parents(".nav-mobile").outerHeight();
                }

                if (
                    elementTop - tolerants - 5 < scrollHeight &&
                    scrollHeight + tolerants + 5 < elementTop + elementHeight
                ) {
                    if (!$this.parent().hasClass("is-active")) {
                        let position = 0;

                        $this
                            .parent()
                            .prevAll()
                            .each((index, element) => {
                                position += $(element).outerWidth(true);
                            });

                        $(".nav-mobile ul").animate(
                            {
                                scrollLeft: position,
                            },
                            300
                        );
                    }

                    $this.parent().addClass("is-active");
                } else {
                    $this.parent().removeClass("is-active");
                }
            }
        });
    }

    $scrollSpyLink.on("click", function (event) {
        event.preventDefault();
        let $this = $(this);
        var $id = $($this.attr("href"));
        // let tolerants = headerHeight;

        let tolerants = getCssVariable("--sticky-header-height");
        if (tolerants === false) tolerants = headerHeight;
        tolerants = parseInt(tolerants);

        if (!!$this.parents(".sticky-band-fulltime").length) {
            tolerants += $this.parents(".nav-mobile").outerHeight();
        }

        $("body, html").animate(
            {
                scrollTop: $id.offset().top - tolerants,
            },
            300
        );
    });

    $(".js-counter").each((index, counter) => {
        let $counter = $(counter);

        $counter.find(".minus").click(function () {
            var $input = $(this).parent().find("input");
            var count = parseInt($input.val()) - 1;
            count = count < 1 ? 1 : count;
            $input.val(count < 10 ? "0" + count : count);
            $input.change();
            return false;
        });
        $counter.find(".plus").click(function () {
            var $input = $(this).parent().find("input");
            var count = parseInt($input.val()) + 1;
            $input.val(count < 10 ? "0" + count : count);
            $input.change();
            return false;
        });
    });

    $(".card .card__btn").on("click", (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $body.addClass("is-card-open");
    });

    $(".card .btn-close").on("click", (e) => {
        e.preventDefault();
        let $this = $(e.currentTarget);
        $body.removeClass("is-card-open");
    });

    $("a.article-block .slick-arrow, a.article-block .slick-dots").on(
        "click",
        (e) => {
            e.preventDefault();
        }
    );

    $(".section-nav a").on("click", function () {
        if ($(this).hasClass("disabled")) return false;
        return true;
    });

    $(".gfield_select option").each((index, element) => {
        if (element.value == "") {
            $(element).addClass("hidden");
        }
    });

    let btnContentWrap = () => {
        let $btns = $(".btn");
        $btns.each((index, btn) => {
            let $btn = $(btn);
            let content = $btn.html();
            $btn.html(`<span>${content}</span><span>${content}</span>`);
        });
    };

    $("body").on("click", "a.latest-news-grid--load-more", function () {
        let $module = $(this).parents(".module--latest-news-grid");
        let $moduleResults = $module.find(".latest-news-grid-results");
        let $moduleActions = $module.find(".section__actions");

        $module.addClass("loading");
        $moduleActions.remove();

        let currentPage = parseInt($(this).data("current-page"));
        let newPage = currentPage + 1;

        $.ajax({
            type: "post",
            url: main_theme.ajax_url,
            dataType: "html",
            data: {
                action: "latest-news-grid",
                page: newPage,
            },
            success: function (response) {
                $moduleResults.append(response);
                $module.removeClass("loading");
                $body.trigger("scroll");
            },
        });
        return false;
    });

    $(".module--latest-news-grid").on(
        "change",
        ".latest-news-grid--taxonomy",
        function () {
            let $module = $(this).parents(".module--latest-news-grid"),
                $moduleResults = $module.find(".latest-news-grid-results"),
                selectedCategory = $(this).val();
            $module.addClass("loading");
            scrollViewportToElem(".module--latest-news-grid");

            $.ajax({
                type: "post",
                url: main_theme.ajax_url,
                dataType: "html",
                data: {
                    action: "latest-news-grid",
                    page: 1,
                    categories: selectedCategory,
                },
                success: function (response) {
                    $moduleResults.html(response);
                    $module.removeClass("loading");
                    $body.trigger("scroll");
                },
            });
        }
    );

    // pagination for all the grids
    let paginations = [
        {
            handler: ".module--previous-exhibitions",
            paginationLink: "a.previousExhibition-pagination",
            resultsElem: ".previous-exhibitions-results",
            action: "previous-exhibitions",
        },
        {
            handler: ".module--book-of-the-week-grid",
            paginationLink: "a.bookOfTheWeekGrid-pagination",
            resultsElem: ".book-of-the-week-grid-results",
            action: "book-of-the-week-grid",
        },
        {
            handler: ".module--research-projects-completed",
            paginationLink: "a.researchProjectGrid-pagination",
            resultsElem: ".research-projects-grid-results",
            action: "research-projects-grid",
        },
        {
            handler: ".module--podcasts-grid",
            paginationLink: "a.podcastsGrid-pagination",
            resultsElem: ".podcasts-grid-results",
            action: "podcasts-grid",
        },
        {
            handler: ".module--curriculum-resources-grid",
            paginationLink: "a.curriculumResourcesGrid-pagination",
            resultsElem: ".curriculum-resources-grid-results",
            action: "curriculum-resources-grid",
        },
        {
            handler: ".module--on-this-day-grid",
            paginationLink: "a.onThisDayGrid-pagination",
            resultsElem: ".on-this-day-grid-results",
            action: "on-this-day-grid",
        },
        {
            handler: ".module--quote-of-the-week-grid",
            paginationLink: "a.qotwGrid-pagination",
            resultsElem: ".quote-of-the-week-grid-results",
            action: "quote-of-the-week-grid",
        },
        {
            handler: ".module--book-store-grid",
            paginationLink: "a.booksGrid-pagination",
            resultsElem: ".book-store-grid-results",
            action: "book-store-grid",
        },
        {
            handler: ".module--further-reading",
            paginationLink: "a.furtherReading-pagination",
            resultsElem: ".further-reading-results",
            action: "further-reading",
        },
    ];
    for (let i in paginations) {
        let thisPagination = paginations[i];
        $(thisPagination.handler).on(
            "click",
            thisPagination.paginationLink,
            function () {
                let $module = $(this).parents(thisPagination.handler),
                    $moduleResults = $module.find(thisPagination.resultsElem),
                    newPage = $(this).data("page"),
                    $loading = $moduleResults;

                if ($(this).hasClass("disabled")) return false;
                if (thisPagination.action == "previous-exhibitions")
                    $loading = $module;
                $loading.addClass("loading");

                let ajaxData = {
                    action: thisPagination.action,
                    page: newPage,
                };
                if (thisPagination.action == "curriculum-resources-grid") {
                    ajaxData.filterOption = $module
                        .find(".curriculum-tags")
                        .val();
                }
                if (thisPagination.action == "further-reading") {
                    ajaxData.pageID = $moduleResults.data("page-id");
                    ajaxData.moduleIndex = $moduleResults.data("module-index");
                }

                $.ajax({
                    type: "post",
                    url: main_theme.ajax_url,
                    dataType: "html",
                    data: ajaxData,
                    success: function (response) {
                        $moduleResults.html(response);
                        if (thisPagination.action == "book-of-the-week-grid") {
                            $body.trigger("scroll");
                            setTimeout(function () {
                                $moduleResults
                                    .find(".slider-base .slider__slides")
                                    .each(function () {
                                        sliderBaseSlider($(this));
                                    });
                                $module.removeClass("loading");
                            }, 400);
                        } else if (
                            thisPagination.action == "previous-exhibitions"
                        ) {
                            $loading.removeClass("loading");
                            $body.trigger("scroll");
                        } else {
                            $body.trigger("scroll");
                            setTimeout(function () {
                                $loading.removeClass("loading");
                                $body.trigger("scroll");
                            }, 400);
                        }
                    },
                });
                return false;
            }
        );
    }

    $(".module--curriculum-resources-grid").on(
        "change",
        "select.curriculum-tags",
        function () {
            let $module = $(this).parents(".module--curriculum-resources-grid"),
                $moduleResults = $module.find(
                    ".curriculum-resources-grid-results"
                ),
                filterOption = $module.find(".curriculum-tags").val();

            if ($(this).hasClass("disabled")) return false;
            $moduleResults.addClass("loading");

            $.ajax({
                type: "post",
                url: main_theme.ajax_url,
                dataType: "html",
                data: {
                    action: "curriculum-resources-grid",
                    page: 1,
                    filterOption: filterOption,
                },
                success: function (response) {
                    $moduleResults.html(response);
                    $body.trigger("scroll");
                    setTimeout(function () {
                        $moduleResults.removeClass("loading");
                        $body.trigger("scroll");
                    }, 400);
                },
            });
        }
    );

    function checkCssVariable(variableName) {
        let bodyStyles = window.getComputedStyle(document.body);
        if (bodyStyles.getPropertyValue(variableName).length > 0) return true;
        return false;
    }

    function getCssVariable(variableName) {
        let bodyStyles = window.getComputedStyle(document.body);
        if (checkCssVariable(variableName)) {
            return bodyStyles.getPropertyValue(variableName);
        }
        return false;
    }

    function scrollViewportToElem(selector, speed = 800) {
        let stickyHeaderHeight = getCssVariable("--sticky-header-height");
        if (stickyHeaderHeight === false) stickyHeaderHeight = 0;
        stickyHeaderHeight = parseInt(stickyHeaderHeight);
        $("html, body").animate(
            {
                scrollTop: $(selector).offset().top - stickyHeaderHeight,
            },
            speed
        );
    }

    headerHeight = $header.outerHeight();
    $body.css("--win-height", $win.outerHeight() + "px");
    heroFixedFunction();
    headerSizes();
    btnContentWrap();

    // search
    $(".field-select-dd input")
        .on("focusin", (e) => {
            let $this = $(e.currentTarget);
            $this
                .parents(".field-select-dd")
                .addClass("is-expanded")
                .find(".field__content")
                .slideDown();
        })
        .on("focusout", (e) => {
            let $this = $(e.currentTarget);
            $this
                .parents(".field-select-dd")
                .removeClass("is-expanded")
                .find(".field__content")
                .slideUp();
        });

    $(".field-select-dd").on("click", " ul li a", (e) => {
        let $this = $(e.currentTarget),
            $input = $this
                .parents(".field-select-dd")
                .find(".field__title input[type=text]")
                .first();
        $input.val($this.html());

		efr_trigger_filter_update();

        return false;
    });

    $("#selectSortBy").on("change", (e) => {
        let $this = $(e.currentTarget);
        $("#searchSortBy").val($this.val());
        $("#search-results-filter").trigger("submit");
    });

    $("#selectView").on("change", (e) => {
        let $this = $(e.currentTarget);
        $("#searchView").val($this.val());
        $("#search-results-filter").trigger("submit");
    });

    $(".updateFilterButton").on("click", function () {
        $("#searchPage").val("1"); // reset page counter as this is a new search now
        return true;
    });
    $("#search-grid-pagination").on(
        "click",
        "a.searchResultsGrid-pagination",
        function () {
            var page = 1;
            if (typeof $(this).attr("data-page") != "undefined") {
                var re = /^[0-9]+$/;
                var selectedPage = $(this).attr("data-page");
                if (re.test(selectedPage) !== false) {
                    $("#searchPage").val(selectedPage);
                    $("#search-results-filter").trigger("submit");
                }
            }
            return false;
        }
    );

    $("#search-results-filter").on("submit", function () {
        let searchTerm = $(
                "#search-results-filter input[name=searchTerm]"
            ).val(),
            searchEntityType = "",
            searchEntityTags = "",
            dateRangeFrom = $("#dateRangeFrom").val(),
            dateRangeTo = $("#dateRangeTo").val(),
            searchSortBy = $("#searchSortBy").val(),
            searchView = $("#searchView").val(),
            searchPage = $("#searchPage").val(),
            title = $("#searchTitle").val(),
            author = $("#searchAuthor").val(),
            year = $("#searchYear").val(),
            country = $("#searchCountry").val(),
            searchCategory = $(
                ".search-filter--searchCategory input[type=radio]:checked"
            ).val(),
            newURL = "";

        if (
            $('#search-results-filter input[name="searchEntityType[]"]:checked')
                .length > 0
        ) {
            $(
                '#search-results-filter input[name="searchEntityType[]"]:checked'
            ).each(function () {
                searchEntityType += "," + $(this).val();
            });
            if (searchEntityType.substr(0, 1) == ",")
                searchEntityType = searchEntityType.substr(
                    1,
                    searchEntityType.length
                );
        }

		if (
            $('#search-results-filter input[name="searchEntityTags[]"]:checked')
                .length > 0
        ) {
            $(
                '#search-results-filter input[name="searchEntityTags[]"]:checked'
            ).each(function () {
                searchEntityTags += "," + $(this).val();
            });
            if (searchEntityTags.substr(0, 1) == ",")
                searchEntityTags = searchEntityTags.substr(
                    1,
                    searchEntityTags.length
                );
        }

        let defaultPublicationDateStart = $("#publication-date-range").data(
                "min"
            ),
            defaultPublicationDateEnd = $("#publication-date-range").data(
                "max"
            );
        if (dateRangeFrom.length > 0) {
            if (defaultPublicationDateStart == dateRangeFrom)
                dateRangeFrom = "";
        }
        if (dateRangeTo.length > 0) {
            if (defaultPublicationDateEnd == dateRangeTo) dateRangeTo = "";
        }

        // clear out some values that we won't be needing
        if (searchCategory != "menziesCollection") {
            title = "";
            author = "";
            year = "";
            country = "";
        }

        // var newURL = window.location.pathname;
        if (searchTerm.length > 0)
            newURL += "query=" + encodeURIComponent(searchTerm) + "&";
        if (searchCategory.length > 0)
            newURL += "category=" + encodeURIComponent(searchCategory) + "&";
        if (searchEntityType.length > 0)
            newURL += "type=" + encodeURIComponent(searchEntityType) + "&";
        if (searchEntityTags.length > 0)
            newURL += "tags=" + encodeURIComponent(searchEntityTags) + "&";
        if (dateRangeFrom.length > 0)
            newURL += "dateFrom=" + encodeURIComponent(dateRangeFrom) + "&";
        if (dateRangeTo.length > 0)
            newURL += "dateTo=" + encodeURIComponent(dateRangeTo) + "&";
        if (title.length > 0)
            newURL += "_title=" + encodeURIComponent(title) + "&";
        if (author.length > 0)
            newURL += "_author=" + encodeURIComponent(author) + "&";
        if (country.length > 0)
            newURL += "country=" + encodeURIComponent(country) + "&";
        if (year.length > 0) newURL += "_year=" + encodeURIComponent(year) + "&";
        if (searchSortBy.length > 0)
            newURL += "sortBy=" + encodeURIComponent(searchSortBy) + "&";
        if (searchView.length > 0)
            newURL += "view=" + encodeURIComponent(searchView) + "&";
        if (searchPage.length > 0)
            newURL += "searchPage=" + encodeURIComponent(searchPage) + "&";
        if (newURL.substr(newURL.length - 1, 1) == "&")
            newURL = newURL.substr(0, newURL.length - 1);
        newURL = window.location.pathname + "?" + newURL;
        // console.log({ newURL: newURL });
        // push this URL to the history
        $("#search-results-filter").attr("action", newURL);
        return true;
    });
    $(".js-header-search-submit").on("click", function () {
        $("#headerSearch").trigger("submit");
        return false;
    });
    $("#headerSearch").on("submit", function () {
        let searchTerm = $("#headerSearch-searchTerm").val(),
            title = $("#headerSearch-searchTitle").val(),
            author = $("#headerSearch-searchAuthor").val(),
            year = $("#headerSearch-searchYear").val(),
            country = $("#headerSearch-searchCountry").val(),
            searchCategory = $("#headerSearch-searchCategory").val(),
            newURL = "";

        if (searchCategory != "menziesCollection") {
            title = "";
            author = "";
            year = "";
            country = "";
        }

        if (searchTerm.length > 0)
            newURL += "query=" + encodeURIComponent(searchTerm) + "&";
        if (searchCategory.length > 0)
            newURL += "category=" + encodeURIComponent(searchCategory) + "&";
        if (title.length > 0)
            newURL += "_title=" + encodeURIComponent(title) + "&";
        if (author.length > 0)
            newURL += "_author=" + encodeURIComponent(author) + "&";
        if (country.length > 0)
            newURL += "country=" + encodeURIComponent(country) + "&";
        if (year.length > 0) newURL += "_year=" + encodeURIComponent(year) + "&";
        if (newURL.substr(newURL.length - 1, 1) == "&")
            newURL = newURL.substr(0, newURL.length - 1);
        newURL = $("#headerSearch").attr("action") + "?" + newURL;

        $("#headerSearch").attr("action", newURL);
        return true;
    });

    $win.on("load", function () {
        intFormFields();
        animateOnScroll();

        $body.css("--win-height", $win.outerHeight() + "px");

        setTimeout(function () {
            $(".accordion--has-slider .accordion__body").css("display", "none");
        }, 200);

        // if ($("body").hasClass("page-template-search")) {
        //     $(
        //         ".search-filter--searchCategory input[type=radio]:checked"
        //     ).trigger("change");
        // }

        if ($('.part--popup-subscribe').length > 0) {
            let subscribePopupCookie = getCookie('rmi_subscribe_popup');
            if (!subscribePopupCookie) {
                // show popup after 10 seconds
                setTimeout(function () {
                    $('.part--popup-subscribe').addClass('is-open');
                    setCookie('rmi_subscribe_popup', 'displayed', 120);
                }, 10000);
            }
        }
    })
    .on("load resize", function () {
        animateOnScroll();
        headerSizes();
        intMobileSliders();
        winWidth = $win.outerWidth();
        isMobileView = winWidth < 767;

        $body.css("--win-height", $win.outerHeight() + "px");
    })
    .on("load scroll", function () {
        scrollHeight = $win.scrollTop();

        headerSizes();
        animateOnScroll();
        stickyAside();
        scrollSpy();

        $body.css("--win-height", $win.outerHeight() + "px");

        if (!!$heroWrapper.length) {
            $body.toggleClass(
                "is-passed-header",
                scrollHeight > $heroWrapper.outerHeight() / 2
            );
            $body.toggleClass(
                "is-sticky-header",
                scrollHeight > $heroWrapper.outerHeight() + headerHeight * 2
            );
        } else {
            $body.toggleClass(
                "is-passed-header",
                scrollHeight > headerHeight * 1.5
            );
            $body.toggleClass(
                "is-sticky-header",
                scrollHeight > headerHeight * 2.5
            );
        }
    });
})(jQuery, window, document);


window.initMap = function() {
    (async function ($, window, document) {
        function loadAjax(filePath) {
            return $.ajax({
                async: false,
                global: false,
                url: filePath,
            }).responseJSON;
        }

        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

        // Visitor info map.
        $('[id^="map"]').each(function () {
            let $map = $(this);
            let iBox;
            let mapData = loadAjax($map.data("mapdata"));
            let markers = [];
            let markersLength = mapData.markers.length;
            let content;
            let markerCluster;
            let clusterIsEnabled = mapData.cluster;

            let map = new google.maps.Map($map.get(0), mapData.mapOptions);

            let marker = new google.maps.Marker({
                position: mapData.markers[0].position,
                map: map,
                icon: mapData.markers[0].icon,
            });
        });


        // Timeline map.
        const $timeline_map = $('#timeline-map');

        if ( $timeline_map.length ) {
            const marker_data_raw = $timeline_map.data('markers');

            const infoWindow = new google.maps.InfoWindow({
                content: "",
            });

            let timeline_map = new google.maps.Map($timeline_map[0], {
                center: {
                    lat: -25.363,
                    lng: 131.044,
                },
                zoom: 4,
                minZoom: 4,
                scrollwheel: false,
                mapId: '1120682c55064792',
                fullscreenControl: false,
                mapTypeControl: false,
                streetViewControl: false,
            });

            // let bounds = new google.maps.LatLngBounds();

            let markers = [];

            for (let i = 0; i < marker_data_raw.length; i++) {
                const marker_data = marker_data_raw[i];

                const marker_html = document.createElement("div");

                marker_html.className = "efr_marker";

                const marker = new google.maps.marker.AdvancedMarkerElement({
                    map     : timeline_map,
                    position: marker_data.position,
                    title   : marker_data.title,
                    content : marker_html,
                });

                markers.push( marker );

                // bounds.extend( marker_data.position );

                marker.addListener("click", () => {
                    infoWindow.setContent( marker_data.html );
                    infoWindow.open(timeline_map, marker);
                });
            }

            // timeline_map.fitBounds(bounds);

            const markerCluster = new markerClusterer.MarkerClusterer({ markers, timeline_map });
        }
    })(jQuery, window, document);
}
